import withInlineContainer       from 'components/ui/json_form/fields/with_inline_container';
import withDestroyValueOnUnmount from 'components/ui/json_form/fields/with_destroy_value_on_unmount';
import withDisabledForm          from 'components/ui/json_form/fields/with_disabled_form';

export const fieldWrapper = () => Component => {
  return withDisabledForm()(withInlineContainer()(withDestroyValueOnUnmount()(Component)));
};
